import(/* webpackMode: "eager" */ "D:\\Project\\NDS\\hq\\wjpncma\\wjpncma-nextjs15\\src\\app\\(dashboard)\\@main\\dashboard\\page.tsx");
